module.exports = __webpack_public_path__ + "static/media/antonvandaal.842ced61.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/antonvandaal.webp
// module id = 534
// module chunks = 0